"use strict";
// ================================================================
// utils/colorUtils.ts
// theme.json の色指定(常にhex)を扱うための小さいユーティリティ群。
// v2/v1問わず使う汎用ロジックなので、ここに置く。
// ================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHex6 = void 0;
exports.isAchromaticColor = isAchromaticColor;
var material_1 = require("@mui/material");
/** #RRGGBB 形式か (アルファ付与できる形式か) を判定する */
var isHex6 = function (color) {
    return !!color && /^#[0-9a-fA-F]{6}$/.test(color);
};
exports.isHex6 = isHex6;
/**
 * 無彩色とみなすchroma(RGB各chの最大値-最小値、0-1)の上限。
 * HSLの彩度(s = chroma / (1 - |2l-1|))は明度が0/1に近づくほど分母が小さくなり、
 * 実際の色差(chroma)がわずかでもsの値だけ跳ね上がる。例えば#fadce4は
 * s=0.75と算出されるが実体はほぼ白に近い薄いピンクで、彩度75%という数値ほど
 * 色は付いていない。chromaは明度に関わらず「実際にRGB各chがどれだけ離れているか」を
 * 直接見るため、この誤判定が起きない。
 */
var ACHROMATIC_CHROMA_THRESHOLD = 0.1;
/**
 * カラーが無彩色(黒/白/低彩度グレー)かどうかを判定する。
 * theme.jsonの色指定は常にhex(alphaなし)なので、rgb()/hexのみ対応する。
 * それ以外の形式(rgba()/hsl()等)・非対応の形式はfalseとして扱わず、無彩色扱い(true)にフォールバックする。
 */
function isAchromaticColor(color) {
    if (!color)
        return true;
    try {
        var _a = (0, material_1.decomposeColor)(color), type = _a.type, values = _a.values;
        if (type !== 'rgb')
            return true;
        var _b = values.map(function (v) { return v / 255; }), r = _b[0], g = _b[1], b = _b[2];
        return Math.max(r, g, b) - Math.min(r, g, b) < ACHROMATIC_CHROMA_THRESHOLD;
    }
    catch (_c) {
        return true;
    }
}
